import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { playPause, updateColor } from '../../../redux/slices/visualSlice';

const MergeSort = ({ countIterations }) => {
  const myState = useSelector(state => state.updateProps);
  const dispatch = useDispatch();
  const timeoutsRef = useRef([]);
  const cancelledRef = useRef(false);

  const clearAllTimeouts = () => {
    cancelledRef.current = true;
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
  };

  const schedule = (fn, delay) => {
    if (cancelledRef.current) return;
    const id = setTimeout(() => {
      if (!cancelledRef.current) fn();
    }, delay);
    timeoutsRef.current.push(id);
  };

  const solve = () => {
    const values = myState.values.map(item => item[0]);
    const ids = myState.values.map(item => item[1]);
    const speed = myState.speed;
    const maxTimer = Math.ceil(Math.log(values.length + 1));

    const mergeSort = (l, r, timer) => {
      if (l >= r) return;
      const mid = Math.floor((l + r) / 2);
      mergeSort(l, mid, timer - 1);
      mergeSort(mid + 1, r, timer - 1);

      schedule(() => {
        countIterations(timer);
        const color = [
          Math.floor(Math.random() * 200),
          Math.floor(Math.random() * 200),
          Math.floor(Math.random() * 200),
        ];
        for (let i = l; i <= r; i++) {
          document.getElementById(ids[i]).childNodes[1].style.backgroundColor =
            `rgb(${color[0]},${color[1]},${color[2]})`;
        }
        for (let i = l; i <= r; i++) {
          for (let j = i + 1; j <= r; j++) {
            if (values[i] > values[j]) {
              [values[i], values[j]] = [values[j], values[i]];
              [ids[i], ids[j]] = [ids[j], ids[i]];
              document.getElementById(ids[i]).style.transform = `translateX(${i * 11}px)`;
              document.getElementById(ids[j]).style.transform = `translateX(${j * 11}px)`;
            }
          }
        }
      }, timer * speed * 5);
    };

    mergeSort(0, values.length - 1, maxTimer);

    schedule(() => {
      dispatch(playPause(false));
      dispatch(updateColor('rgb(0, 182, 0)'));
    }, 5 * speed * (1 + maxTimer) + 50);
  };

  useEffect(() => {
    if (myState.algorithm === 'merge' && myState.play) {
      clearAllTimeouts();
      cancelledRef.current = false;
      solve();
    }
    return clearAllTimeouts;
  }, [myState.play]);

  useEffect(() => {
    return clearAllTimeouts;
  }, [myState.algorithm, myState.values]);

  return <></>;
};

export default MergeSort;
